
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.463 1.555l.532-.532a.525.525 0 00-.742-.742l-1.4 1.4a.525.525 0 000 .742l1.4 1.4a.525.525 0 00.742-.742l-.462-.462A5.061 5.061 0 113.48 3.921a.525.525 0 00-.7-.77 6.125 6.125 0 104.69-1.596h-.007z","fill":"#585858"}}),_c('path',{attrs:{"d":"M9.255 7.667a.2.2 0 010 .346l-3.6 2.079a.2.2 0 01-.3-.174V5.763a.2.2 0 01.3-.174l3.6 2.079z","fill":"#585858"}})])
          )
        }
      }
    